import React from 'react'
import { DivInput } from '../atoms/DivInput';
import EditorDraft from '../atoms/EditorDraft';

const InputEditorHtml = ({
  label,
  name,
  value,
  onChange,
  sectionName,
  isRequired,
  colLabel = 4,
  colInput = 8,
  placeholder = `Ingresar ${label}`,
  direction = "row",
  minHeight = "12rem",
  maxHeight = "20rem",
  toolbarOptions,
}) => {
  const handleOnChange = (res) => {
    const textHtml = (res === undefined || res === "<p><br></p>") ? null : res;
    let data = {
      target: {
        value: textHtml,
        name: name,
      },
    };
    onChange(data);
  };

  return (
    <DivInput direction={direction} colLabel={colLabel} colInput={colInput}>
      <label className={`modal-label ${isRequired ? "required" : ""}`}>
        {label}
      </label>
      <div className={`black-color`}>
        <EditorDraft
          placeholder={placeholder}
          handleChange={handleOnChange}
          value={value}
          fixedHeight={minHeight}
          toolbarOptions={toolbarOptions}
        />
        {sectionName && name && (
          <p
            className="ficha-form-input-validation-message"
            id={`ficha-edit-${sectionName}-${name}-validation-message`}
          ></p>
        )}
      </div>
    </DivInput>
  )
}

export default InputEditorHtml